import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { NO_AUTH_LOCATION_PATHNAME } from 'constants';

import { makeSelectIsAuthenticated } from 'reducers/auth/selectors';
import SubscriptionLimitModal from 'components/modal/SubscriptionLimitModal';

const LOGIN_PATH = `${window._env_.production ? '/ui' : ''}/login`;
function LoggedInRoute(props) {
  const { component: Component, isAuthenticated, location, ...rest } = props;

  if (!isAuthenticated) {
    const lastPosition = JSON.parse(localStorage.getItem(NO_AUTH_LOCATION_PATHNAME));
    const redirectUrl = lastPosition?.expiresAt >= new Date().getTime() && lastPosition?.pathName;
    if (!redirectUrl) {
      localStorage.setItem(
        NO_AUTH_LOCATION_PATHNAME,
        JSON.stringify({
          expiresAt: new Date().getTime() + 5 * 60000,
          pathName: `${location.pathname}${location.search}`,
        }),
      );
    }
  }

  const renderChidlren = (renderProps) =>
    !isAuthenticated ? (
      <Redirect to={{ pathname: LOGIN_PATH, state: { from: location } }} />
    ) : (
      <Fragment>
        <Component {...renderProps} />

        <SubscriptionLimitModal />
      </Fragment>
    );

  return <Route {...rest} render={renderChidlren} />;
}

LoggedInRoute.propTypes = {
  location: PropTypes.object,
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
});

export default connect(mapStateToProps)(LoggedInRoute);
